import React from 'react';

import {
  Box,
  Typography,
} from '@mui/material';

type Props = {
  children: React.ReactNode;
  heading: string;
};

const HeadingContainerDRT: React.FC<Props> = ({
  children,
  heading,
}: Props) => (
  <Box>
    <Typography role="heading" variant="h4" sx={{ m: 2 }}>{heading}</Typography>
    <Box sx={{ m: 2 }}>
      {children}
    </Box>
  </Box>
);

export default HeadingContainerDRT;
